var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-group-toggle"},_vm._l((_vm.options),function(option,index){return _c('label',{key:index,staticClass:"btn mb-1",class:[
              { active: _vm.value === option.value },
              { alt: _vm.altValue === option.value },
              { disabled: _vm.disabled },
              _vm.buttonClasses,
              option.classes ? option.classes : ''
            ],on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.select(option.value)}}},[_c('input',{attrs:{"type":"radio","id":"option1","autocomplete":"off","disabled":_vm.disabled},domProps:{"value":option.value,"checked":option.value == _vm.value}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(option.label)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }